import { createRouter, createWebHistory } from 'vue-router';
import Home from '../views/HomeView.vue';
import ChartView from '../views/chartView.vue';
import Post from '../views/PostView.vue';
import Login from "@/views/LoginView";
import store from "../store";
import workshopUser from "@/views/workshopUser";
import WorkshopView from "@/views/workshopView.vue";
import WorkshopNotice from "@/views/workshopNotice.vue";
import TaskConfigView from "@/views/TaskConfigView.vue"; // Importiere die ConfigView
import TaskView from "@/views/TaskView.vue"; // Importiere die TaskView
import CustomerDashboard from '@/views/CustomerDashboard.vue'
import RiskAnalysisDashboard from '@/views/RiskAnalysisDashboard.vue';
import { getAuth, signOut } from 'firebase/auth';

const routes = [
  // Keep root route; guard will redirect based on role and last initiative
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { requiresAuth: true, roles: ['super_admin', 'company_admin', 'department_admin', 'project_admin', 'company_member', 'department_member', 'project_member', 'guest'] }
  },
  {
    path: '/customer/:customerId/risk-analysis',
    name: 'RiskAnalysis',
    component: RiskAnalysisDashboard,
    meta: { requiresAuth: true, roles: ['super_admin', 'company_admin', 'department_admin', 'project_admin', 'company_member', 'department_member', 'project_member'] }
  },
  {
    path: '/chart',
    name: 'Chart',
    component: ChartView,
    meta: { requiresAuth: true, roles: ['super_admin', 'company_admin'] }
  },
  {
    path: '/customer/:customerId/department/:departmentId/project/:projectId/workshop/:id',
    name: 'Workshop',
    component: WorkshopView,
    meta: { requiresAuth: true, roles: ['super_admin', 'company_admin', 'department_admin', 'project_admin', 'company_member', 'department_member', 'project_member', 'guest'] }
  },
  {
    path: '/customer/:customerId/workshop/:id',
    name: 'WorkshopGlobal',
    component: WorkshopView,
    meta: { requiresAuth: true, roles: ['super_admin', 'company_admin', 'department_admin', 'project_admin', 'company_member', 'department_member', 'project_member', 'guest'] }
  },
  {
    path: '/customer/:customerId/workshop/:id/notice',
    name: 'Notice',
    component: WorkshopNotice,
    meta: { requiresAuth: true, roles: ['super_admin', 'company_admin', 'department_admin', 'project_admin', 'company_member', 'department_member', 'project_member', 'guest'] }
  },
  {
    path: '/post/:id',
    name: 'Post',
    component: Post,
    props: true,
    meta: { requiresAuth: true, roles: ['super_admin', 'company_admin', 'department_admin', 'project_admin', 'company_member', 'department_member', 'project_member'] }
  },
  {
    path: '/customer/:customerId/workshop/join/:workshopId/:lang',
    name: 'WorkshopUser',
    component: workshopUser,
    props: true,
    meta: { requiresAuth: false }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/customer/:customerId/config',
    name: 'Config',
    component: TaskConfigView,
    meta: { requiresAuth: true, roles: ['super_admin', 'company_admin', 'department_admin', 'project_admin'] }
  },
  {
    path: '/customer/:customerId/workshop/:id/tasks',
    name: 'Tasks',
    component: TaskView,
    meta: { requiresAuth: true, roles: ['super_admin', 'company_admin', 'department_admin', 'project_admin', 'company_member', 'department_member', 'project_member'] }
  },
  {
    path: '/customer/:customerId/dashboard',
    name: 'CustomerDashboard',
    component: CustomerDashboard,
    props: true,
    meta: { requiresAuth: true, roles: ['super_admin', 'company_admin', 'department_admin', 'project_admin', 'company_member', 'department_member', 'project_member', 'guest'] }
  }
];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

router.beforeEach(async (to, from, next) => {
  // Support explicit logout via query, e.g. /?logout=1
  if (to.query && to.query.logout === '1') {
    try {
      const auth = getAuth();
      await signOut(auth);
    } catch (e) {
      // ignore
    }
    // Clear volatile session data
    try { sessionStorage.clear(); } catch (e) { /* ignore */ }
    store.commit('setUser', null);
    store.commit('setUserProfile', null);
    return next('/login');
  }
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const allowedRoles = to.meta.roles;
  const user = store.getters.userProfile;

  if (requiresAuth && !store.getters.currentUser) {
    await store.dispatch('fetchUser');
      if (!store.getters.currentUser) {
      return next('/login');
    }
    await store.dispatch('fetchUserProfile');
  }

  // Role-aware redirect for root path
  if (to.path === '/') {
    // Ensure profile is loaded for accurate role check
    if (!store.getters.userProfile && store.getters.currentUser) {
      await store.dispatch('fetchUserProfile');
    }
    const profile = store.getters.userProfile;
    const role = profile?.role;
    const adminRoles = ['super_admin', 'company_admin', 'department_admin', 'project_admin'];
    if (adminRoles.includes(role)) {
      return next('/chart');
    } else {
      const customerId = store.getters.getCustomerId;
      const workshopId = store.getters.getWorkshopId;
      if (customerId && workshopId) {
        return next(`/customer/${customerId}/workshop/${workshopId}`);
      }
      return next('/login');
    }
  }

  if (requiresAuth && allowedRoles && user && !allowedRoles.includes(user.role)) {
    // Not authorized for this route
    return next('/login');
      }

    next();
});

export default router;
